import React from "react";
import { Box, Pagination, Select, MenuItem, Typography } from "@mui/material";

const PaginationComponent = ({
  currentPage,
  totalPages,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  return (
    <Box
      mt={4}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={2}
    >
      {/* Page Number Pagination */}
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(_, value) => onPageChange(value)}
        color="primary"
        shape="rounded"
        sx={{
          "& .MuiPaginationItem-root": {
            "&:focus": {
              outline: "none",
            },
            "&.Mui-focusVisible": {
              outline: "none",
              backgroundColor: "transparent",
            },
          },
        }}
      />

      {/* Items Per Page Selector */}
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2">Rows per page:</Typography>
        <Select
          size="small"
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
        >
          {[20, 30, 40, 50, 100].map((num) => (
            <MenuItem key={num} value={num}>
              {num}
            </MenuItem>
          ))}
        </Select>
      </Box>
    </Box>
  );
};

export default PaginationComponent;
